__turbopack_context__.v({
  "button-highlight": "HomeStyleSegmentedControl-module__5NAplW__button-highlight",
  "container": "HomeStyleSegmentedControl-module__5NAplW__container",
  "pill": "HomeStyleSegmentedControl-module__5NAplW__pill",
  "root": "HomeStyleSegmentedControl-module__5NAplW__root",
  "tabCount": "HomeStyleSegmentedControl-module__5NAplW__tabCount",
  "tabHighlight": "HomeStyleSegmentedControl-module__5NAplW__tabHighlight",
  "tabLabel": "HomeStyleSegmentedControl-module__5NAplW__tabLabel",
  "tabLabelInner": "HomeStyleSegmentedControl-module__5NAplW__tabLabelInner",
});
